<template>
    <van-popup v-model="visible" position="left" close-on-click-overlay @click-overlay="cancel" @close="cancel">
        <div class="username" @click="handleUserClick">
            <div>
                <van-image
                    round
                    width="3rem"
                    height="3rem"
                    :src="userInfo.avatar || require('@/assets/images/icons/user_avatar.png')"
                />
                <span>{{ userInfo.nickname || '未登录' }}</span>
            </div>
            <van-icon name="arrow" />
        </div>

        <van-tabbar v-model="active" route>
            <van-tabbar-item name="home" to="/home">
                <template #icon>
                    <van-icon class-prefix="icon" name="compass" size="20" />
                </template>
                首页
            </van-tabbar-item>
            <van-tabbar-item name="intercession" to="/user/intercession">
                <template #icon>
                    <van-icon class-prefix="icon" name="detail" size="20" />
                </template>
                代祷
            </van-tabbar-item>
            <!-- <van-tabbar-item name="note" to="/note">
                <template #icon>
                    <van-icon class-prefix="icon" name="edit" size="20" />
                </template>
                笔记
            </van-tabbar-item>
            <van-tabbar-item name="music" to="/sermon">
                <template #icon>
                    <van-icon class-prefix="icon" name="file-text" size="20" />
                </template>
                讲课
            </van-tabbar-item> -->
            <van-tabbar-item name="setting" to="/setting">
                <template #icon>
                    <van-icon class-prefix="icon" name="setting" size="20" />
                </template>
                设置
            </van-tabbar-item>
            <van-tabbar-item name="about" icon="warning-o" to="/about">
                <template #icon>
                    <van-icon class-prefix="icon" name="warning-circle" size="20" />
                </template>
                关于
            </van-tabbar-item>
        </van-tabbar>
    </van-popup>
</template>

<script>
import { LOGIN_USER } from '@/utils/constants'

export default {
    name: 'UserCenter',
    data() {
        return {
            visible: false,
            active: '',
            userInfo: {},
        }
    },
    created() {
        if (this.$ls.get(LOGIN_USER)) {
            this.userInfo.nickname = this.$ls.get(LOGIN_USER).nickname
            this.userInfo.avatar = this.$ls.get(LOGIN_USER).avatar
        }
    },
    methods: {
        show() {
            this.visible = true
        },
        cancel() {
            this.visible = false
        },
        handleUserClick() {
            if (this.userInfo) {
                this.$router.push('/user')
            } else {
                this.$router.push('/login')
            }
        },
    },
}
</script>

<style lang="less" scoped>
.van-popup {
    width: 75%;
    height: 100%;
    padding: 30px 20px;
    box-sizing: border-box;
}

.username {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .van-image {
        vertical-align: middle;
        margin-right: 15px;
    }
}

.van-hairline--top-bottom::after {
    border-width: 0;
}

.van-tabbar {
    position: relative;
    display: flex;
    flex-direction: column;

    .van-tabbar-item {
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        padding: 10px;
        margin-bottom: 10px;
        border-radius: @medium-border-radius;

        /deep/ .van-tabbar-item__icon {
            margin: 0 15px 0 0;
            font-size: 20px;
        }

        /deep/ .van-tabbar-item__text {
            font-size: @medium-font-size;
        }
    }

    .van-tabbar-item--active {
        color: #1677ff;
        background-color: @blue-bg;
    }
}
</style>
